<template>
  <div class="pipelineComponents">
    <b-container fluid>
      <b-alert show variant="warning">
        <p>Please note the criteria for "Unfinished" events has temporarily changed to ONLY include unfinished `header-localization` OR `intensity-dm-pipeline` events.</p>
        For more details, please check out
        <a href="https://github.com/CHIMEFRB/frb-web/issues/86" target="_blank"> this issue</a>.
      </b-alert>
      <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/Analysis/pipeline_components.vue" target="_blank" style="color:black">
        <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
      </a>
      <!-- Show Events -->
      <b-tabs
        active-nav-item-class="font-weight-bold text-warning"
        content-class="mt-3"
      >
        <b-tab title="Team's Events">
          <b-form-group
            v-if="['SCIENCE PIPELINE EXPERT', 'PROJECT OFFICE', 'FRB COORDINATOR'].includes(userRole)"
            label="Select Team:"
            label-for="myform"
          >
            <b-form-select
                    id="myform"
                    v-model="userTeam"
                    :options="teams"
                    size="sm"
                    @input="getAllData()"
                    class="mr-1"
                    required
                ></b-form-select>
          </b-form-group>
          <b-tabs active-nav-item-class="font-weight-bold text-warning" content-class="mt-3">
            <b-tab title="Unfinished" active>
              <table-component
                :pageOptions="pageOptions"
                :numrows="unsavedEvents.length"
                :items="unsavedEvents"
                :fields="eventFields"
                :perPage="perPage"
                :smallTable="smallTable"
                :showSource="showSource"
                :generateAll="generateAll"
                :checkIfBaseband="checkIfBaseband"
                :notesSelected="notesSelected"
              ></table-component>
          </b-tab>
          <b-tab title="Saved">
            <table-component
                :pageOptions="pageOptions"
                :numrows="savedEvents.length"
                :items="savedEvents"
                :fields="eventFields"
                :perPage="perPage"
                :smallTable="smallTable"
                :showSource="showSource"
                :generateAll="generateAll"
                :checkIfBaseband="checkIfBaseband"
                :notesSelected="notesSelected"
              ></table-component>
          </b-tab>
          <b-tab title="Flagged Events">
            <table-component
                :pageOptions="pageOptions"
                :numrows="flaggedEvents.length"
                :items="flaggedEvents"
                :fields="eventFields"
                :perPage="perPage"
                :smallTable="smallTable"
                :showSource="showSource"
                :generateAll="generateAll"
                :checkIfBaseband="checkIfBaseband"
                :notesSelected="notesSelected"
              ></table-component>
          </b-tab>
          <b-tab title="Bad Events">
            <table-component
                :pageOptions="pageOptions"
                :numrows="badEvents.length"
                :items="badEvents"
                :fields="eventFields"
                :perPage="perPage"
                :smallTable="smallTable"
                :showSource="showSource"
                :generateAll="generateAll"
                :checkIfBaseband="checkIfBaseband"
                :notesSelected="notesSelected"
              ></table-component>
          </b-tab>
        </b-tabs>
        </b-tab>
        <b-tab title="My Events" active>
          <b-tabs content-class="mt-3">
          <b-tab title="Unfinished" active>
              <table-component
                :pageOptions="pageOptions"
                :numrows="myunsavedEvents.length"
                :items="myunsavedEvents"
                :fields="eventFields"
                :perPage="perPage"
                :smallTable="smallTable"
                :showSource="showSource"
                :generateAll="generateAll"
                :checkIfBaseband="checkIfBaseband"
                :notesSelected="notesSelected"
              ></table-component>
          </b-tab>
          <b-tab title="Saved">
            <table-component
                :pageOptions="pageOptions"
                :numrows="mysavedEvents.length"
                :items="mysavedEvents"
                :fields="eventFields"
                :perPage="perPage"
                :smallTable="smallTable"
                :showSource="showSource"
                :generateAll="generateAll"
                :checkIfBaseband="checkIfBaseband"
                :notesSelected="notesSelected"
              ></table-component>
          </b-tab>
          <b-tab title="Flagged Events">
            <table-component
                :pageOptions="pageOptions"
                :numrows="myflaggedEvents.length"
                :items="myflaggedEvents"
                :fields="eventFields"
                :perPage="perPage"
                :smallTable="smallTable"
                :showSource="showSource"
                :generateAll="generateAll"
                :checkIfBaseband="checkIfBaseband"
                :notesSelected="notesSelected"
              ></table-component>
          </b-tab>
          <b-tab title="Bad Events">
            <table-component
                :pageOptions="pageOptions"
                :numrows="mybadEvents.length"
                :items="mybadEvents"
                :fields="eventFields"
                :perPage="perPage"
                :smallTable="smallTable"
                :showSource="showSource"
                :generateAll="generateAll"
                :checkIfBaseband="checkIfBaseband"
                :notesSelected="notesSelected"
              ></table-component>
          </b-tab>
          </b-tabs>
        </b-tab>
      </b-tabs>
      <b-tabs
        active-nav-item-class="font-weight-bold text-warning"
        content-class="mt-3"
        pills
      >
        <b-tab title="Realtime" active>
          <div id="eventViewer" style="display:none">
            <b-embed id="eventPlot" type="iframe" aspect="1by1" src=""></b-embed>
          </div>
        </b-tab>
        <b-tab title="DM pipeline">
          <dm-pipeline
            :rerunIntensityDM="rerunIntensityDM"
            :monitorJob="monitorJob"
            :unsaveParameters="unsaveParameters"
            :saveParameters="saveParameters"
            :flagParameters="flagParameters"
            :badParameters="badParameters"
            :intensityDmPipelineItems="intensityDmPipelineItems"
          ></dm-pipeline>
        </b-tab>
        <b-tab title="Fitburst">
          <fitburst
              :rerunfitburst="rerunfitburst"
              :monitorJob="monitorJob"
              :unsaveParameters="unsaveParameters"
              :saveParameters="saveParameters"
              :flagParameters="flagParameters"
              :badParameters="badParameters"
              :fitburstItems="fitburstItems"
            ></fitburst>
        </b-tab>
        <b-tab title="MCMC">
          <fitburstmcmc
              :unsaveParameters="unsaveParameters"
              :saveParameters="saveParameters"
              :flagParameters="flagParameters"
              :badParameters="badParameters"
              :fitburstMCMCItems="fitburstMCMCItems"
            ></fitburstmcmc>
        </b-tab>
        <b-tab title="Flux/Fluence">
          <fluence
            :rerunintensitycalibration="rerunintensitycalibration"
            :monitorJob="monitorJob"
            :unsaveParameters="unsaveParameters"
            :saveParameters="saveParameters"
            :flagParameters="flagParameters"
            :badParameters="badParameters"
            :fluenceItems="fluenceItems"
          ></fluence>
        </b-tab>
        <b-tab title="Localization">
          <details open>
            <summary style="font-size:20px" id="header-localization-summary"> Header Localization</summary>
            <header-localization
              :rerunHeaderLocalization="rerunHeaderLocalization"
              :monitorJob="monitorJob"
              :rerunheaderloc="rerunheaderloc"
              :unsaveParameters="unsaveParameters"
              :saveParameters="saveParameters"
              :flagParameters="flagParameters"
              :badParameters="badParameters"
              :HeaderLocalizationItems="HeaderLocalizationItems"
            ></header-localization>
          </details>
          <details>
            <summary style="font-size:20px" id="intensity-localization-summary"> Intensity Localization</summary>
            <intensity-localization
              :unsaveParameters="unsaveParameters"
              :saveParameters="saveParameters"
              :flagParameters="flagParameters"
              :badParameters="badParameters"
              :intensityLocalizationItems="intensityLocalizationItems"
            ></intensity-localization>
          </details>
          </b-tab>
          <b-tab title="Baseband">
            <baseband
              :unsaveParameters="unsaveParameters"
              :saveParameters="saveParameters"
              :flagParameters="flagParameters"
              :badParameters="badParameters"
              :basebandItems="basebandItems"
            ></baseband>
          </b-tab>
        </b-tabs>
        <details style="text-center" open>
          <summary style="font-size:30px">Show Job Status</summary>
          <b-table show-empty
               :stacked="md"
               dark
               sticky-header="400px"
               responsive
               :items="jobStatus"
               :fields="jobStatusFields"
          >
          <template #cell(status)="row">
            <b-icon v-if="row.item.status==='Finished'" icon="check-square-fill" aria-hidden="true" font-scale="1.5" variant="success"></b-icon>
            <b-icon v-else-if="row.item.status==='In Progress'" icon="arrow-clockwise" aria-hidden="true" font-scale="1.5" variant="primary" animation="spin-pulse"></b-icon>
            <b-icon v-else icon="three-dots" variant="warning" font-scale="1.5"></b-icon>
          </template>
          </b-table>
        </details>
      <!-- Diagnostic Plot Modal-->
      <b-modal size="lg" id="modalplots" ok-only>
        <h2>Diagnostic Plots</h2>
        <b-row>
          <b-col md="auto" class="my-1">
            <vue-plotly :data="data1" :layout="layout1" :options="options1"/>
          </b-col>
          <b-col md="auto" class="my-1">
            <vue-plotly :data="data2" :layout="layout2" :options="options2"/>
          </b-col>
          <b-col md="auto" class="my-1">
            <vue-plotly :data="data3" :layout="layout3" :options="options3"/>
          </b-col>
        </b-row>
      </b-modal>
      <!-- Rerun Fitburst Modal -->
      <b-modal id="fitburst-modal"
                     title="Fitburst Parameters"
                     @ok="rerunFitburst"
      >
        <rerun-fitburst
          :fitburstForm="fitburstForm"
          :rerunFitburst="rerunFitburst"
        ></rerun-fitburst>
      </b-modal>

      <!-- Rerun DM Pipeline Modal -->
      <b-modal id="intensity-dm-pipeline-modal"
                     title="Intensity DM Pipeline Parameters"
                     @ok="rerunIntensityDMPipeline"
      >
        <rerun-dm-pipeline
          :intensityDMPipelineForm="intensityDMPipelineForm"
          :rerunIntensityDMPipeline="rerunIntensityDMPipeline"
        ></rerun-dm-pipeline>
      </b-modal>
      <b-modal id="intensity-calibration-modal"
                     title="Intensity Calibration Parameters"
                     @ok="rerunIntensityCalibration"
      >
        <rerun-fluence
          :intensityCalibrationForm="intensityCalibrationForm"
          :rerunIntensityCalibration="rerunIntensityCalibration"
        ></rerun-fluence>
      </b-modal>
      <b-modal id="take-notes-modal"
        title="Take notes for this event"
        @ok="saveNotes"
      >
        <div v-for="(round, index) in Object.keys(takenNotes)" :key="index">
          <div class="d-block text-left">
            <h6>{{round}}</h6>
          </div>
          <div class="container" >
            <p>{{takenNotes[round]}}</p>
          </div>
        </div>
        <div class="d-block text-left">
            <h6>{{userName}}</h6>
          </div>
        <b-form @submit="saveNotes">
          <textarea class="form-control" v-model="eventNotes" aria-label="Take Notes: "></textarea>
        </b-form>
      </b-modal>
      <b-modal id="show-notes-modal"
        title="Showing notes taken for this event"
      >
        <div v-for="(round, index) in Object.keys(takenNotes)" :key="index">
          <div class="d-block text-left">
            <h6>{{round}}</h6>
          </div>
          <div class="container" >
            <p>{{takenNotes[round]}}</p>
          </div>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>
<style>
.container {
  font-size: 14px;
    border-left: 3px solid #60DF88 !important;
    padding: 5px;
    background-color: rgb(239, 255, 241);
}
</style>
<script>
import { AnalysisMixin } from '../mixins/analysisMixin.js'
import VuePlotly from '@statnett/vue-plotly'
import VueCsvDownloader from 'vue-csv-downloader'
import tableComponent from '../tableComponent'
import dmPipeline from '../dmPipeline'
import fitburst from '../fitburst'
import fitburstmcmc from '../fitburstMCMC'
import calibration from '../calibration'
import headerLoc from '../headerLoc'
import intensityLoc from '../intensityLoc'
import baseband from '../baseband'
import rerunFluence from '../rerunFluence'
import rerunIntensityDMComponent from '../rerunIntensityDMComponent'
import rerunFitburst from '../rerunFitburst'

var baseUrl = 'https://frb.chimenet.ca/frb-master/'
// baseUrl = 'http://localhost:8001/'
export default {
  components: {
    VuePlotly,
    VueCsvDownloader,
    'table-component': tableComponent,
    'dm-pipeline': dmPipeline,
    'fitburst': fitburst,
    'fitburstmcmc': fitburstmcmc,
    'fluence': calibration,
    'header-localization': headerLoc,
    'intensity-localization': intensityLoc,
    'baseband': baseband,
    'rerun-fluence': rerunFluence,
    'rerun-dm-pipeline': rerunIntensityDMComponent,
    'rerun-fitburst': rerunFitburst
  },
  mixins: [AnalysisMixin],
  data () {
    return {
      teamItems: {'1': [], '2': []},
      roleItems: {'systemExperts': [], 'runCoordinator': [], 'teamLeaders': [], 'pipelineExperts': [], 'members': []},
      teamFields: [],
      roleFields: [],
      unsavedEvents: [],
      savedEvents: [],
      flaggedEvents: [],
      badEvents: [],
      myunsavedEvents: [],
      mysavedEvents: [],
      myflaggedEvents: [],
      mybadEvents: [],
      teamMembers: {'1': [{ text: 'Select One', value: null }], '2': [{ text: 'Select One', value: null }]},
      userRole: 'MEMBER',
      userTeam: '',
      userName: '',
      assignTo: '',
      takenNotes: [],
      form: {
        name: '',
        team: null,
        role: null,
        options: [{ value: null, text: 'Please select an option' }],
        checked: []
      },
      teams: [{ text: 'Select One', value: null }, '1', '2', '3', '4'],
      roles: [{ text: 'Select One', value: null }, 'SYSTEM EXPERT', 'RUN COORDINATOR', 'PIPELINE EXPERT', 'TEAM LEADER', 'MEMBER'],
      submitStatus: null,
      eventFields: [
        {key: 'event_id', sortable: true, label: 'Event Id', 'class': 'text-left'},
        {key: 'assigned_users', sortable: true, label: 'Assigned To', 'class': 'text-left'},
        {key: 'snr', sortable: true, label: 'SNR', 'class': 'text-left'},
        {key: 'dm', sortable: true, label: 'DM', 'class': 'text-left'},
        {key: 'ra', sortable: true, label: 'RA', 'class': 'text-left'},
        {key: 'dec', sortable: true, label: 'DEC', 'class': 'text-left'},
        {key: 'header-localization', sortable: true, label: 'HDR Loc', 'class': 'text-left'},
        {key: 'intensity-dm-pipeline', sortable: true, label: 'DM pipeline', 'class': 'text-left'},
        {key: 'intensity-fitburst', sortable: true, label: 'Fitburst', 'class': 'text-left'},
        {key: 'intensity-calibration', sortable: true, label: 'Fluence', 'class': 'text-left'},
        {key: 'intensity-localization', sortable: true, label: 'Int Loc', 'class': 'text-left'},
        {key: 'baseband', sortable: true, label: 'Baseband', 'class': 'text-left'},
        {key: 'actions', label: 'Actions', 'class': 'text-left'}
      ],
      previousItem: {},
      previousEvent: {},
      mybaseUrl: 'https://frb.chimenet.ca/frb-master/',
      // mybaseUrl: 'http://localhost:8001',
      baseUrl: baseUrl,
      items: [],
      fields: [],
      evItems: [],
      evFields: [],
      eventId: null,
      fitburstItems: [],
      fitburstMCMCItems: [],
      rerunfitburst: false,
      rerunheaderloc: false,
      rerunIntensityDM: false,
      rerunintensitycalibration: false,
      basebandItems: [],
      basebandData: false,
      intensityDmPipelineItems: [],
      intensityLocalizationItems: [],
      HeaderLocalizationItems: [],
      fluenceItems: [],
      showfields: [],
      jobStatus: [],
      smallTable: true,
      dark: false,
      fixed: true,
      perPage: 5,
      // totalRows: items.length,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      sortBy: null,
      plot: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      modalInfo: { title: '', content: '' }
    }
  },
  mounted () {
    this.items = []
    this.refreshToken()
    this.userName = localStorage.userName
    var authHeaders = {'Authorization': localStorage.accessToken}
    this.$http.get(this.baseUrl + '/v1/admin/role/' + localStorage.username, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
      .then(response => {
        this.getUserRole(response.body)
        this.$http.get(this.baseUrl + '/v1/admin/team/' + localStorage.username, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
          .then(response => {
            this.userTeam = response.body
            this.getDelayedData(2000)
          })
      })
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.showfields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    },
    nameState () {
      return this.knownsource.length > 7
    },
    totalRows () {
      return this.items.length
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Analysis/pipeline_components.vue